"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = exports.HEADERS = exports.UI_CUSTOM = exports.UI_DEFAULT = exports.EVENT_LOADED = exports.EVENT_ERROR = exports.EVENT_REJECTED = exports.EVENT_ACCEPTED = exports.BTN_REJECT_ID = exports.BTN_REJECT = exports.BTN_ACCEPT_ID = exports.BTN_ACCEPT = exports.TITLE = void 0;
exports.TITLE = 'Terms And Conditions';
exports.BTN_ACCEPT = 'Accept';
exports.BTN_ACCEPT_ID = 'gcpt-accept';
exports.BTN_REJECT = 'Decline';
exports.BTN_REJECT_ID = 'gcpt-decline';
exports.EVENT_ACCEPTED = 'GCP_TERM_ACCEPTED';
exports.EVENT_REJECTED = 'GCP_TERM_DECLINED';
exports.EVENT_ERROR = 'GCP_TERM_ERROR';
exports.EVENT_LOADED = 'GCP_TERM_LOADED';
exports.UI_DEFAULT = 'default';
exports.UI_CUSTOM = 'custom';
exports.HEADERS = {
    'Content-Type': 'application/json',
};
class DEFAULT_OPTIONS {
    constructor() {
        this.url = '/';
        this.headers = {};
        this.title = exports.TITLE;
        this.content = null;
        this.ui = exports.UI_DEFAULT;
        this.force = false;
    }
}
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
;
